import React from "react";
import styled from "styled-components";
import FormComponent from "../../components/core-components/FormComponent.tsx";
import { translations } from "../../../utils/translations.js";
import { useSelector } from "react-redux";
// import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import { SlLocationPin } from "react-icons/sl";
import { BsTelephone } from "react-icons/bs";
import { HiOutlineMailOpen } from "react-icons/hi";
import { LuBriefcaseBusiness } from "react-icons/lu";
import { sendEmail } from "../../../services/orderService.js";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;

  @media (max-width: 600px) {
    width: 85%;
  }
`;

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  max-width: 900px;
  background-color: #fff;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  overflow: hidden;
  border-radius: 10px;

  @media (min-width: 950px) {
    flex-direction: row;
    width: 70%;
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  flex: 1;
  padding: 3rem;
`;

const PageTitle = styled.h1`
  color: var(--secondary-font-color);
`;

const InfoWrapper = styled.div`
  flex: 0.4;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 1rem;
  text-align: left;
  height: 100%;
  min-height: 300px;
  border-top: 1px solid var(--white-gray-color);

  @media (min-width: 950px) {
    border-top: none;
    padding: 2rem;
    height: auto;
    background-color: var(--background-green);
  }
`;

const ContactItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  margin: 0.5rem 0;

  & svg {
    font-size: 1.5rem;
  }
`;

const SupportPage = () => {
  const languageCode = useSelector((state) => state.settings.languageCode);

  const notify = () =>
    toast.success("Mesaj trimis !", {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "light",
    });

  const contactConfig = [
    {
      placeholder: "email@example.com",
      type: "email",
      isRequired: true,
      name: "from_email",
      label: translations[languageCode]["contact-form-email"],
    },
    {
      placeholder: "Info...",
      type: "text",
      isRequired: true,
      name: "subject",
      label: translations[languageCode]["contact-form-subject"],
    },
    {
      placeholder: "Hi FiloPrint!",
      type: "textarea",
      isRequired: true,
      name: "message",
      label: translations[languageCode]["contact-form-msg"],
    },
  ];

  // const handleSend = (data) => {
  //   emailjs.send(
  //     "service_filoprint",
  //     "template_fkfqb0j",
  //     data,
  //     "OAaWqyGuQ-d_slar1"
  //   );
  //   notify();
  // };

  const handleSend = async (data) => {
    const mail = {
      toAddress: "contact@filoprint.ro",
      subject: data.subject + " de la " + data.from_email,
      content: `<p> ${data.message}</p>`,
    };

    try {
      await sendEmail(mail);
      notify();
    } catch (error) {
      console.error("Error sending email", error);
    }
  };

  return (
    <Wrapper>
      <ModalWrapper>
        <FormWrapper>
          <PageTitle>Contact</PageTitle>
          <FormComponent
            onSave={handleSend}
            saveButtonLabel={translations[languageCode]["contact-form-save"]}
            fields={contactConfig}
            formId="contact-form"
          />
        </FormWrapper>

        <InfoWrapper>
          <ContactItem>
            <LuBriefcaseBusiness /> 43031922 - J15/937/10.09.2020
          </ContactItem>
           <ContactItem>
            <SlLocationPin /> Bd Timisoara 101T, Sector 6, Bucuresti
          </ContactItem>
          <ContactItem>
            <SlLocationPin /> Str. Liliacului, Nr. 9, Doicesti, Dambovita
          </ContactItem>
          
          <ContactItem>
            <BsTelephone /> +40724702368
          </ContactItem>
          <ContactItem>
            <HiOutlineMailOpen /> contact@filoprint.ro
          </ContactItem>
        </InfoWrapper>
      </ModalWrapper>
      <ToastContainer />
    </Wrapper>
  );
};

export default SupportPage;
